import { render, staticRenderFns } from "./OSHConversations.vue?vue&type=template&id=2461d1c0&"
import script from "./OSHConversations.vue?vue&type=script&lang=js&"
export * from "./OSHConversations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports